module.exports = __webpack_public_path__ + "img/album01_07.4979102c.jpg";